export default $axios => ({
    postOrder(data) {
        return $axios({
            method: 'POST',
            url: `/general/v3/order/`,
            data: data
        });
    },
    getOrdersHistory(params) {
        return $axios({
            method: 'GET',
            url: `/general/v2/order`,
            params: params
        });
    },
    getCheckPaymentStatus(id) {
        return $axios({
            method: 'GET',
            url: `/general/v2/order/${id}/check-payment-status/`
        });
    },
    getOrder(id) {
        return $axios({
            method: 'GET',
            url: `/general/v2/order/${id}`,
            redirectOnError: true
        });
    }
});
